// src/components/AuthenticityBadge/AuthenticityBadge.js
import React from 'react';
import './AuthenticityBadge.css';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faShieldHalved } from '@fortawesome/free-solid-svg-icons';
// ✅ Changed from faShieldCheck to faShieldHalved

const AuthenticityBadge = ({ productId, compact = false }) => {
  const verification = {
    verified: true,
    status: 'VERIFIED',
    message: 'Blockchain Verified'
  };

  if (!verification) return null;

  if (compact) {
    return (
      <div className={`authenticity-badge-compact ${verification.verified ? 'verified' : 'unverified'}`}>
        <FontAwesomeIcon icon={faShieldHalved} />
        <span>{verification.verified ? 'Verified' : 'Unverified'}</span>
      </div>
    );
  }

  return (
    <div className={`authenticity-badge-compact ${verification.verified ? 'verified' : 'unverified'}`}>
      <FontAwesomeIcon icon={faShieldHalved} />
      <span>Verified</span>
    </div>
  );
};

export default AuthenticityBadge;
